import { Page } from '../../../core/entities/page/page';
import { gql } from 'apollo-angular';
import { Tour } from 'src/app/tour-planning/shared/entities/tour';

export const TOURS_QUERY = gql`
query getToursQuery(
  $pageNumber: Int, $pageSize: Int, $sortProperty: String, $locationId: UUID,
  $fromDate: String, $toDate: String,
  $sortDirection: String,  $states:[TourState],
)
{
  tours: getToursPaged(
    filter: { states: $states, locationId: $locationId,
    fromDateTime:  $fromDate, toDateTime: $toDate,
    sortRequest: {sortProperties: [$sortProperty], sortDirection: $sortDirection},
    pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection},
  }) {
    totalPages
      totalElements
      number
      size
      content{
        id
        name
        effectiveDepartureDateTime
        effectiveArrivalDateTime
        driver{
          id
          firstName
          lastName
        }
        resource {
          id
          name
        }
        tasks{
          state
        }
      }

  }
}`;

export interface TourQueryResponse {
  tours: Page<Tour>;
  loading: boolean;
}
